import React, { useContext, useEffect, useState } from "react";
import * as S from "./SaquesFeitosStyle";
import { formatNumber, formatDate } from "../ASSETS/assets";
import Loading from "../Loader";
import { AuthContext } from "../../Context/AuthContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaSearch, FaTimes, FaFileInvoiceDollar } from "react-icons/fa";
import { useMessage } from "../../Context/MessageContext";
import ModalCreateReceipt from "../Saques/ModalCreateReceipt";

export default function SaquesFeitos() {
  const { withdrawals, totalWithdrawals, getSaques, authState } =
    useContext(AuthContext);
  const [search, setSearch] = useState("");
  const [contractSearch, setContractSearch] = useState("");
  const [load, setLoad] = useState(false);
  const [sortOrder, setSortOrder] = useState("desc");
  const [statusFilter, setStatusFilter] = useState("2");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [modalConta, setModalConta] = useState(null);
  const [modalCancel, setModalCancel] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [modalReceiptData, setModalReceiptData] = useState(null);
  const navigate = useNavigate();
  const { showMessage } = useMessage();

  const totalPages = Math.ceil(totalWithdrawals / itemsPerPage);

  const fetchSaques = async (page) => {
    setLoad(true);
    const offset = (page - 1) * itemsPerPage;
    try {
      await getSaques(
        itemsPerPage,
        offset,
        sortOrder,
        statusFilter,
        search,
        startDate,
        endDate,
        contractSearch
      );
    } catch (e) {
      console.log(e);
    } finally {
      setLoad(false);
    }
  };

  useEffect(() => {
    if (
      authState.permission &&
      authState.permission !== "ALL" &&
      !authState.permission.includes("VER SAQUES")
    ) {
      navigate("/");
    }
  }, [authState.permission, navigate]);

  useEffect(() => {
    fetchSaques(currentPage);
  }, [currentPage, sortOrder, statusFilter]);

  const handleSearch = () => {
    setCurrentPage(1);
    fetchSaques(1);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleStatus = (status) => {
    switch (status) {
      case 1:
        return "Pendente";
      case 2:
        return "Pago";
      case 3:
        return "Cancelado";
      case 4:
        return "Cancelado";
      default:
        return "Cancelado";
    }
  };

  const handleChangeStatus = async (id, newStatus) => {
    setLoad(true);
    try {
      var res = await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}withdraw/${id}/newstatus/${newStatus}`
      );
      if (res.status === 200) {
        fetchSaques(currentPage);
        showMessage("Transação cancelada com sucesso.", "success");
        setModalCancel(null);
      } else {
        showMessage("Erro ao cancelar transação.", "error");
      }
    } catch (error) {
      console.log(error);
      showMessage("Erro ao cancelar transação.", "error");
    } finally {
      setLoad(false);
    }
  };

  console.log(withdrawals)

  const openInNewTab = (url) => {
    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <>
      <S.SaquesContainer>
        {modalConta && (
          <S.ModalConta>
            <div className="box">
              <button onClick={() => setModalConta(null)} className="close">
                <FaTimes />
              </button>
              <h3 className="title">Dados Bancários</h3>
              <div className="account">
                <div className="boxzinha">
                  <strong>Cliente:</strong> {modalConta.clientName}
                </div>
                <div className="boxzinha">
                  <strong>Banco:</strong>{" "}
                  {modalConta.clientBankAccount?.bank || "Não informado"}
                </div>
                <div className="boxzinha">
                  <strong>Agência:</strong>{" "}
                  {modalConta.clientBankAccount?.agencyNumber ||
                    "Não informado"}
                </div>
                <div className="boxzinha">
                  <strong>Conta:</strong>{" "}
                  {modalConta.clientBankAccount?.accountNumber ||
                    "Não informado"}
                </div>
                <div className="boxzinha">
                  <strong>Tipo:</strong>{" "}
                  {modalConta.clientBankAccount?.accountType || "Não informado"}
                </div>
                <div className="boxzinha">
                  <strong>PIX:</strong>{" "}
                  {modalConta.clientBankAccount?.pixKey || "Não informado"}
                </div>
              </div>
            </div>
          </S.ModalConta>
        )}

        {modalCancel && (
          <S.ModalConta>
            <div className="box">
              <button onClick={() => setModalCancel(null)} className="close">
                <FaTimes />
              </button>
              <h3 className="title">Confirmar Cancelamento</h3>
              <div className="account">
                <p style={{ color: "#fff" }}>
                  Deseja realmente cancelar o saque de{" "}
                  <strong>{modalCancel.clientName}</strong> no valor de{" "}
                  <strong>
                    R$ {formatNumber(modalCancel.withdraw.amountWithdrawn || 0)}
                  </strong>
                  ?
                </p>
              </div>
              <div className="ask">
                <S.ActionButton
                  className="cancel"
                  onClick={() => handleChangeStatus(modalCancel.withdraw.id, 4)}
                >
                  Sim, Cancelar!
                </S.ActionButton>
              </div>
            </div>
          </S.ModalConta>
        )}

        <Loading load={load} />

        <S.ContentBox>
          <S.SaquesFirstContent>
            <S.AreaTitle>Histórico de Saques</S.AreaTitle>
          </S.SaquesFirstContent>

          <S.Filtros>
            <S.SearchBar>
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                type="text"
                placeholder="Pesquisar cliente ou CPF..."
                onKeyPress={(e) => e.key === "Enter" && handleSearch()}
              />
              <button onClick={handleSearch}>
                <FaSearch />
              </button>
            </S.SearchBar>

            <S.FiltroStatus>
              <div className="box">
                <span className="title">ID Contrato</span>
                <input
                  type="number"
                  placeholder="ID..."
                  value={contractSearch}
                  onChange={(e) => setContractSearch(e.target.value)}
                  onKeyPress={(e) => e.key === "Enter" && handleSearch()}
                  className="selectBox"
                />
              </div>
              <div className="box">
                <span className="title">Início</span>
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  className="selectBox"
                />
              </div>
              <div className="box">
                <span className="title">Fim</span>
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  className="selectBox"
                />
              </div>
              <div className="box">
                <span className="title">STATUS</span>
                <select
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                  className="selectBox"
                >
                  <option value="2">Pagos</option>
                  <option value="3">Cancelados</option>
                </select>
              </div>
              <div className="box">
                <span className="title">ORDEM</span>
                <select
                  value={sortOrder}
                  onChange={(e) => setSortOrder(e.target.value)}
                  className="selectBox"
                >
                  <option value="desc">Mais Recentes</option>
                  <option value="asc">Mais Antigos</option>
                </select>
              </div>
            </S.FiltroStatus>
          </S.Filtros>

          <S.TableContainer>
            <S.Table>
              <S.TableHeader>
                <S.TableRow>
                  <S.TableHeaderCell>ID</S.TableHeaderCell>
                  <S.TableHeaderCell>Cliente</S.TableHeaderCell>
                  <S.TableHeaderCell>Data</S.TableHeaderCell>
                  <S.TableHeaderCell>Valor</S.TableHeaderCell>
                  <S.TableHeaderCell>
                    Fundos (Contrato/Indicação)
                  </S.TableHeaderCell>
                  <S.TableHeaderCell>Reversão para ctr.</S.TableHeaderCell>
                  <S.TableHeaderCell>Para Golden Box?</S.TableHeaderCell>
                  <S.TableHeaderCell>Conta</S.TableHeaderCell>
                  <S.TableHeaderCell>Status</S.TableHeaderCell>
                  <S.TableHeaderCell>Data de Pagamento</S.TableHeaderCell>
                  <S.TableHeaderCell>Opções</S.TableHeaderCell>
                  <S.TableHeaderCell>Recibo</S.TableHeaderCell>
                </S.TableRow>
              </S.TableHeader>
              <S.TableBody>
                {withdrawals &&
                  withdrawals.map((user) => (
                    <S.TableRow key={user.withdraw.id}>
                      <S.TableCell>{user.withdraw.id}</S.TableCell>
                      <S.TableCell>{user.clientName}</S.TableCell>
                      <S.TableCell>
                        {formatDate(user.withdraw.dateCreated)}
                      </S.TableCell>
                      <S.TableCell>
                        R$ {formatNumber(user.withdraw.amountWithdrawn || 0)}
                      </S.TableCell>
                      <S.TableCell>
                        {user.withdraw.contractId
                          ? "#" + user.withdraw.contractId
                          : "Saque de Indicação"}
                      </S.TableCell>
                      <S.TableCell>
                        {user.withdraw.forContractBuyingId
                          ? "#" + user.withdraw.forContractBuyingId
                          : "Saque Normal"}
                      </S.TableCell>
                      <S.TableCell>
                        {user.withdraw.description &&
                        (user.withdraw.description
                          .toLowerCase()
                          .includes("golden box") || user.withdraw.description
                          .toLowerCase()
                          .includes("caixinha")) ? (
                          <S.GoldenStatus isGolden={true}>Sim</S.GoldenStatus>
                        ) : (
                          <S.GoldenStatus isGolden={false}>Não</S.GoldenStatus>
                        )}
                      </S.TableCell>
                      <S.TableCell>
                        <S.ActionButton onClick={() => setModalConta(user)}>
                          Ver Conta
                        </S.ActionButton>
                      </S.TableCell>
                      <S.TableCell>
                        {handleStatus(user.withdraw.status)}
                      </S.TableCell>
                      <S.TableCell>
                        {user.withdraw.paymentDate
                          ? formatDate(user.withdraw.paymentDate)
                          : "Não Informado"}
                      </S.TableCell>
                      <S.TableCell>
                        {user.withdraw.status === 2 ? (
                          <S.ActionButton
                            className="cancel"
                            onClick={() => setModalCancel(user)}
                          >
                            Cancelar
                          </S.ActionButton>
                        ) : (
                          "Nenhuma"
                        )}
                      </S.TableCell>
                      <S.TableCell>
                        {user.withdraw.receiptUrl ? (
                          <S.ActionButton
                            onClick={() =>
                              openInNewTab(user.withdraw.receiptUrl)
                            }
                            title="Ver Recibo"
                          >
                            <FaFileInvoiceDollar style={{ marginRight: 5 }} />{" "}
                            Ver Recibo
                          </S.ActionButton>
                        ) : (
                          <S.ActionButton
                            onClick={() => setModalReceiptData(user)}
                            title="Anexar Recibo"
                          >
                            <FaFileInvoiceDollar style={{ marginRight: 5 }} />{" "}
                            Anexar
                          </S.ActionButton>
                        )}
                      </S.TableCell>
                    </S.TableRow>
                  ))}
              </S.TableBody>
            </S.Table>
          </S.TableContainer>

          <S.PaginationContainer>
            <S.PaginationButton
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Anterior
            </S.PaginationButton>
            <span>
              Exibindo{" "}
              {Math.min((currentPage - 1) * itemsPerPage + 1, totalWithdrawals)}{" "}
              a {Math.min(currentPage * itemsPerPage, totalWithdrawals)} de{" "}
              {totalWithdrawals}
            </span>
            <S.PaginationButton
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage >= totalPages}
            >
              Próxima
            </S.PaginationButton>
          </S.PaginationContainer>
        </S.ContentBox>
      </S.SaquesContainer>

      {modalReceiptData && (
        <ModalCreateReceipt
          withdrawData={modalReceiptData}
          onClose={() => {
            setModalReceiptData(null);
            fetchSaques(currentPage);
          }}
        />
      )}
    </>
  );
}
